import { Component, OnInit } from '@angular/core';
import {LoginService} from "lps-navigation";
import {EnvironmentService} from "../../core/enviroment/environment.service";

@Component({
  selector: 'app-legacy-logout',
  templateUrl: './legacy-logout.component.html',
  styleUrls: ['./legacy-logout.component.scss']
})
export class LegacyLogoutComponent implements OnInit {

  constructor(private loginService: LoginService,
              private environmentService: EnvironmentService) { }

  ngOnInit(): void {
    this.loginService.removeAuthInformation(null);
    window.location.href = this.environmentService.getEnvVar('base_url_portal');
  }

}
